/**
 * Last UI/UX pass (Codex Z2): the drawer's word on a failed transfer-history read (`transfer-list`) — what failed, the
 * reason, and Retry. A failed refresh keeps the rows already listed, so it says the list may be out of date instead.
 */
import { AlertTriangle } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import type { TransferHistoryRead } from '../store/transfersStore';

export function TransferHistoryNotice({ read, hasRows, onRetry }: { read: TransferHistoryRead; hasRows: boolean; onRetry: () => void }) {
  if (read.state !== 'failed') return null;
  return (
    <div role="alert" className="flex items-start gap-2 rounded-md border border-warning/40 bg-warning/10 px-3 py-2 text-xs text-foreground" data-testid="transfers-history-failed">
      <AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0 text-warning" aria-hidden="true" />
      <div className="min-w-0 flex-1 [overflow-wrap:anywhere]">
        <p className="font-medium">Couldn't read the transfer history.{hasRows ? ' The list may be out of date.' : ''}</p>
        <p className="text-muted-foreground">{read.message}</p>
      </div>
      <Button variant="outline" size="xs" className="shrink-0" onClick={onRetry} data-testid="transfers-history-retry">Retry</Button>
    </div>
  );
}
